import React from 'react';
import {
    Bouton,
    GroupeBouton,
    Modale,
    ModaleContent,
    ModaleFooter,
} from '@design-system-etat/dsfr-react';
import PropTypes from 'prop-types';

const ModaleArme = ({ message, modaleOuverte, onClickFunction }) => {
    return (
        <>
            {modaleOuverte && (
                <Modale closeCallback={onClickFunction} taille="lg">
                    <ModaleContent>
                        Votre demande d&apos;ajout d&apos;arme {message} a été transmise à votre
                        préfecture de rattachement et sera traitée dans les meilleurs délais.
                        <br />
                        <br />
                        L&apos;arme apparaîtra dans votre râtelier numérique une fois votre demande
                        validée par la préfecture.
                    </ModaleContent>
                    <ModaleFooter>
                        <GroupeBouton alignementHorizontal="right" isHorizontal>
                            <Bouton label="Ok" niveau="primaire" onClick={onClickFunction} />
                        </GroupeBouton>
                    </ModaleFooter>
                </Modale>
            )}
        </>
    );
};

ModaleArme.propTypes = {
    message: PropTypes.string,
    modaleOuverte: PropTypes.bool,
    onClickFunction: PropTypes.func,
};

export default ModaleArme;
